// React Lib
import React, { useState } from "react";
// Component Styles
import { useStyles } from "./LatestActivityStyles";
// @otg-one/ui_components/components
import { Button, Typography, Separator } from "../index";
// @otg-one/ui_components/icons
import { Settings } from "../../sap_icons";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
const LatestActivityList = (props) => {
    const classes = useStyles(props);
    const [isHover, setIsHover] = useState(false);
    const { id, style, activity } = props;
    const handleOnMouseOver = () => {
        setIsHover(true);
    };
    const handleOnMouseOut = () => {
        setIsHover(false);
    };
    return (React.createElement("div", { className: classes.latestActivityList, onMouseOver: handleOnMouseOver, onMouseOut: handleOnMouseOut, style: style },
        React.createElement("div", { id: `${id}-activity-picture`, className: classes.activityListPicture },
            React.createElement("img", { src: activity.img, width: "40", height: "40", style: { borderRadius: "50%", objectFit: "contain" } })),
        React.createElement("div", { className: classes.activityListName },
            React.createElement(Typography, { id: `${id}-activity-name`, fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[300] }, activity.name)),
        React.createElement("div", { className: classes.activityListInfo },
            React.createElement(Typography, { id: `${id}-activity-info`, fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[300] }, activity.activity)),
        React.createElement("div", { className: classes.activityListDate },
            React.createElement(Typography, { id: `${id}-activity-date`, fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[300] }, activity.date)),
        React.createElement("div", { className: classes.activityListTime },
            React.createElement(Typography, { id: `${id}-activity-time`, fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[300] }, activity.time)),
        isHover && (React.createElement("div", { className: classes.activityListAction },
            React.createElement(Settings, { id: `${id}-activity-settings`, style: {
                    width: 24,
                    height: 24,
                    color: Color.primary[600]
                } })))));
};
export const LatestActivity = (props) => {
    const classes = useStyles(props);
    const { id, style, activities, textLatestActivity, textGoToActivityMonitor } = props;
    return (React.createElement("div", { id: id, className: classes.latestActivityContainer, style: style },
        React.createElement(Typography, { id: `${id}-latest-activity`, fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: Color.neutral[0] }, textLatestActivity),
        React.createElement("div", { id: `${id}-latest-activity-list-container`, className: classes.latestActivityListContainer }, activities.map((activity, index) => (React.createElement(React.Fragment, null,
            React.createElement(LatestActivityList, { id: `${id}-${index}`, key: `${activity.name}-${index}`, activity: activity }),
            index !== activities.length - 1 && React.createElement(Separator, null))))),
        React.createElement(Button, { id: `${id}-latest-activity-monitor-button`, type: "secondary", color: "white", alignIcon: "right", style: { marginTop: 5 } }, textGoToActivityMonitor)));
};
LatestActivity.defaultProps = {
    activities: [],
    textLatestActivity: 'Latest Activity',
    textGoToActivityMonitor: 'Go to Activity Monitor'
};
export default React.memo(LatestActivity);
